<script setup lang="ts">
import { ref } from 'vue'
import QrcodeVue, { Level, RenderAs } from 'qrcode.vue'

const { userMetadata } = useAuthStore()
const { t } = useLocale()

const renderAs = ref<RenderAs>('svg')
const level = ref<Level>('H')
const value = computed(
  () => `${userMetadata?.mcId}|${userMetadata?.firstname}|${userMetadata?.cpf}`
)
const contentQR = { tKey: 'onboarding.stepQR', action: true, isLast: true }
</script>

<template>
  <PopperWrapper data-popper="stepQR" placement="bottom">
    <div class="relative flex h-32 w-full rounded-md bg-mcd-main shadow-xl md:w-96">
      <img class="absolute h-full" alt="qr bg" src="/images/QRCard/group2007.svg" />
      <div class="flex w-full flex-col justify-end p-3">
        <div class="flex items-center gap-2">
          <h4 class="text-xl">
            {{ t('profile.tooltipProfile.greeting') }}
          </h4>
          <h4 class="text-xl font-bold">{{ userMetadata?.firstname }}</h4>
        </div>
        <div class="text-xs">McID: {{ userMetadata?.mcId }}</div>
      </div>
      <figure class="relative w-2/3">
        <img
          class="absolute bottom-0 right-0 h-full w-full rounded-md"
          src="/images/QRCard/Vector.svg"
          alt="qr background"
        />
        <qrcode-vue
          class="absolute right-5 h-full"
          :value="value"
          :level="level"
          :render-as="renderAs"
        />
      </figure>
    </div>
    <template #content="{ close }">
      <McdPopper :close="close" :content="contentQR" />
    </template>
  </PopperWrapper>
</template>
